@import "../../styles/variables.scss";
@import "../../styles/mixin.scss";

.report-error-button {
  align-self: flex-end;
  margin-top: 32px;
}
